module.exports = __webpack_public_path__ + "img/razzo-head-page-3.7ea2b2a9.png";